import * as _ from 'lodash';

/**
 * Use case :
 *  ['a', 1, 'a', 2, '1'].filter(unique);
 * @param value
 * @param index
 * @param self
 */
export function unique(value, index, self) {
    return self.indexOf(value) === index;
}